import { GetContextMenuItemsParams, GridOptions, MenuItemDef } from '@ag-grid-enterprise/all-modules';

type itemAddLine = (index: number) => { [key: string]: any };

class AggridUtils {
	private constructor() { }

	public static contextMenuAddLines(params: GetContextMenuItemsParams, item: itemAddLine = () => { return {}; }, lock: boolean = false) {
		const addLine = {
			name: 'Ajouter une ligne',
			icon: '<ap-icon name="add"></ap-icon>',
			disabled: lock,
			action: () => {
				this.addLine(params, item(0));
			}
		};

		const addLines = {
			name: 'Ajouter plusieurs lignes',
			icon: '<ap-icon name="add"></ap-icon>',
			disabled: lock,
			subMenu: [{
				name: '5 lignes',
				action: () => {
					const data: any[] = [];
					for (let i = 0; i < 5; i++) {
						data.push(item(i));
					}

					this.addLines(params, data);
				}
			}, {
				name: '10 lignes',
				action: () => {
					const data: any[] = [];
					for (let i = 0; i < 10; i++) {
						data.push(item(i));
					}

					this.addLines(params, data);
				}
			}, {
				name: '20 lignes',
				action: () => {
					const data: any[] = [];
					for (let i = 0; i < 20; i++) {
						data.push(item(i));
					}

					this.addLines(params, data);
				}
			}]
		};

		const insertLine = {
			name: 'Intercaler une ligne',
			icon: '<ap-icon name="page-separator"></ap-icon>',
			disabled: lock,
			action: () => {
				this.insertLine(params, item(0));
			}
		};

		const res: MenuItemDef[] = [addLine, addLines];

		if (params.node && !params.node.rowPinned) {
			res.push(insertLine);
		}

		return res;
	}

	public static addLine(params: GridOptions, data: { [key: string]: any }) {
		let index = 0;

		params.api?.forEachNode(() => {
			index++;
		});

		params.api?.applyTransaction({
			add: [data]
		});

		params.api?.ensureIndexVisible(index - 1);
	}

	public static addLines(params: GridOptions, data: { [key: string]: any }[]) {
		let index = 0;

		params.api?.forEachNode(() => {
			index++;
		});

		params.api?.applyTransaction({
			add: data
		});

		params.api?.ensureIndexVisible(index - 1);
	}

	public static insertLine(params: GetContextMenuItemsParams, data: { [key: string]: any }) {
		params.api?.applyTransaction({
			add: [data],
			addIndex: (params.node.rowIndex || 0) + 1
		});
	}

	public static insertLines(params: GetContextMenuItemsParams, data: { [key: string]: any }[]) {
		params.api?.applyTransaction({
			add: data,
			addIndex: (params.node.rowIndex || 0) + 1
		});
	}

	public static getQuickFilter(params: GridOptions) {
		//TODO: passer par this._gridOptions.api?.getQuickFilter() dispo dans la dernier version (mettre à jour Ag-grid)
		//@ts-ignore
		return params.api?.columnController.gridApi.filterManager.quickFilter;
	}
}

export default AggridUtils;
